export default __webpack_public_path__ + "static/media/mBTC.e524360e.svg";